import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const FiltersContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  margin: theme.spacing(2, 0)
}))
